import { render, staticRenderFns } from "./PartnerAcceptForm.vue?vue&type=template&id=511cd2f2&"
import script from "./PartnerAcceptForm.vue?vue&type=script&lang=js&"
export * from "./PartnerAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports